<template>
    <router-link :to="{name: 'tag', params: {language: language, slug: item.slug}}"
                 class='tag-item'>
        <span v-if='language === "en" && item.description'
              v-html='item.description'></span>
        <span v-else
              v-html='item.name'></span>
    </router-link>
</template>

<script>
export default {
  name: 'dsTagItem',
  props: ['language', 'item']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';

.tag-item {
  display: block;
  text-transform: uppercase;
  text-decoration: none;
  border: 0;
  color: $secondary-color;
  hyphens: auto;
  font-size: $small-text;
  &:visited {
    color: $secondary-color;
  }
  &:hover {
    color: $main-color;
    text-decoration: none;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// dsTagItem.vue?409da757